export default "__VITE_ASSET__sJcs_eao__"